//** NEW TEMPLATE
import React, { useEffect, useRef, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import renderLangString from "../../languageStrings";
import AlphaLogo from "../../img/logo.png";
import Icon from "../icons/Icon";

// REDUX
import { useSelector, useDispatch } from "react-redux";
import ACTIONS from "../../actions/types";

// COMPONENT
import GlobalNav from "./GlobalNav";
import Layout from "../layout/Layout";
import TogglePageScroller from "../features/TogglePageScroller";
import NavSeperator from "../navigations/NavSeperator";
import ModalBackground from "../modals/ModalBackground";
import ModalPortal from "../modals/ModalPortal";

// HOOKS
import useResizeScreen from "../../hooks/useResizeScreen";

const MainAsideNav = ({ children, header, footer, onScroll, history }) => {
  const screenSize = useResizeScreen();
  const isMainMenuVisible = useSelector(store => store.app.isMainMenuVisible);
  const sizeOfTheScreen = useSelector(store => store.app.sizeOfTheScreen);
  const isMainMenuVisibleOnTop = useSelector(store => store.app.isMainMenuVisibleOnTop);
  const dispatch = useDispatch();

  useEffect(() => {
    if (sizeOfTheScreen === "mobile") {
      dispatch({ type: ACTIONS.HIDE_MAIN_MENU });
    } else if (sizeOfTheScreen === "desktop") {
      dispatch({ type: ACTIONS.SHOW_MAIN_MENU });
    }
  }, [sizeOfTheScreen]);

  const handleBlackModalBackgroundClick = () => {
    dispatch({ type: ACTIONS.HIDE_MAIN_MENU_ON_TOP });
  };

  const homeLink = history.location.pathname.split("/").slice(0, 3).join("/") + "/dashboard";

  return (
    <aside
      className={`__mn bc12 ${isMainMenuVisible ? "" : "__mn_h"} ${
        isMainMenuVisibleOnTop ? "__mn_t" : ""
      }`}
      data-name="MainAsideNav"
    >
      {/* <GlobalNav /> */}
      <div className="__n">
        <Link aria-label={renderLangString({ id: "$_0" })} to={homeLink}>
          <Icon iconId="globalNavLogo" addClass="__he_ic c1" />
        </Link>
        <NavSeperator header={header} footer={footer} onScroll={onScroll}>
          {children}
        </NavSeperator>
      </div>
      {isMainMenuVisibleOnTop && (
        <ModalPortal>
          <ModalBackground clicked={handleBlackModalBackgroundClick} />
        </ModalPortal>
      )}
    </aside>
  );
};

export default withRouter(MainAsideNav);
